import { useCallback } from 'react'
import { app } from 'config'
import { analytics } from 'config/segment'
import { getDeviceForTracking } from 'utils/analytics'
import { useGoogleTagManagerTrack } from './googleTagManager/useGoogleTagManagerTrack'
import { getStoredAttributionProperties, getStoredUtmCampaignOptions } from './utmCampaignContext'

export const useEventTracking = () => {
  const googleTagManagerTrack = useGoogleTagManagerTrack()

  const track = useCallback(
    async (event: string, properties?: object) => {
      const attributionProperties = getStoredAttributionProperties()

      const allProperties = {
        ...attributionProperties,
        ...properties,
        $device: getDeviceForTracking()
      }
      const options = getStoredUtmCampaignOptions()

      analytics.track(event, allProperties, options)
      googleTagManagerTrack(event, allProperties)

      if (!app.analyticsEnabled) {
        // eslint-disable-next-line no-console
        console.debug('track', event, allProperties)
      }
    },
    [googleTagManagerTrack]
  )

  return track
}
